/**
 * Mutations for events
 */
export const mutations = {
  setValidated(state, value) {
    state.validated = value;
  }
};
